import { MsalService } from '@azure/msal-angular';

import { APP_INITIALIZER, Provider } from '@angular/core';
import { EMPTY, from, Observable } from 'rxjs';
import { User } from '@sentry/angular';
import { AuthService } from './core/services/auth.service';

//MiddleWare qui récupère le token de connexion si existant
export function initializeAppFactory(authService: AuthService): () => Observable<User> {
    return () => {
        let token = localStorage.getItem('Authorization');
        if (token) {
            token = token.slice(7); //Remove 'Bearer '
            return from(authService.registerToken(token));
        } else {
            return EMPTY;
        }
    };
}

export function msalInitializeFactory(msal: MsalService) {
    return () => msal.instance.initialize(); // <-- must be awaited by Angular
}

export const MSAL_BOOTSTRAP_PROVIDER: Provider = {
    provide: APP_INITIALIZER,
    useFactory: msalInitializeFactory,
    deps: [MsalService],
    multi: true,
};
